// extracted by mini-css-extract-plugin
export default {"icon":"card-heading-icon-jHKtKC","title":"card-heading-title-eEvjEX"};